import Vue from 'vue'
import wxSDK from './wxSDK.service'
import ibj from '../api/index'
// const getManyImage  = () => {
//   return new Promise(async (resolve, reject) => {
//     try {
//       await wxSDK.jsSDKConfig()
//       const { localIds } = await wxSDK.chooseManyImage()
//       // alert(`选择图片完成1${localIds}`)
//       const file = await wxSDK.getLocalImgData(localIds[0])
//       // alert('获取base64转换成file', file)
//       Vue.prototype.$toast({
//         type: 'loading',
//         message: '正在上传中...',
//         overlay: true,
//         duration: 0,
//         forbidClick: true,
//       })
//       const resp = await infoClient().put(file.name, file)
//       // alert('阿里云oss', resp)
//       if (resp.res.status !== 200) {
//         Vue.prototype.$toast('上传失败')
//         reject('上传失败')
//       }
//       console.log(resp)
//       let imgUrl = resp.res.requestUrls[0]
//       Vue.prototype.$toast('上传成功')
//       resolve(imgUrl)
//     } catch (error) {
//       Vue.prototype.$toast(`上传失败`)
//       reject(error)
//     }
//   })
// }



// 调用接口上传图片
export default (file) => {
  return new Promise(async (resolve, reject) => {
    try {
      const fileObj = new File([file],file.name,{type:file.type})
      const formData = new FormData()
      formData.append("file",fileObj)
      const res = await ibj.upload(formData)
      if (res.code !== 200) {
        Vue.prototype.$toast(`上传失败`)
        reject('上传失败')
      }
      let imgUrl = res.data && res.data.realm + res.data.address
      resolve(imgUrl)
    } catch (error) {
      Vue.prototype.$toast(`上传失败`)
      reject(error)
    }
  })
}

